<script lang="ts">
  import type { AppState } from '../state/app.svelte';
  import type { IsoDate, YearMonth } from '../data/types';
  import Icon from '../ui/Icon.svelte';
  import PeriodPicker from './PeriodPicker.svelte';

  let { state }: { state: AppState } = $props();

  function updatePeriod(from: string, to: string): void {
    if (state.filterMode === 'stock') {
      state.fromMonth = from as YearMonth;
      state.toMonth = to as YearMonth;
    } else {
      state.fromDate = from as IsoDate;
      state.toDate = to as IsoDate;
    }
    state.syncUrl();
  }
  let scopeSummary = $derived(
    `${state.accountFilterActive ? (state.accountIds.length ? `${state.accountIds.length} conti` : 'Nessun conto') : 'Tutti i conti'}${
      state.categoryFiltersAvailable
        ? ` · ${state.categoryFilterActive ? (state.categoryIds.length ? `${state.categoryIds.length} categorie` : state.includeUncategorized ? 'Senza categoria' : 'Nessuna categoria') : 'Tutte le categorie'}`
        : ''
    }`,
  );
</script>

<section class="filter-bar" aria-label="Filtri attivi">
  <p class="filter-bar-label desktop-only">Ambito</p>
  <PeriodPicker
    mode={state.filterMode === 'stock' ? 'month' : 'date'}
    from={state.filterMode === 'stock' ? state.fromMonth : state.fromDate}
    to={state.filterMode === 'stock' ? state.toMonth : state.toDate}
    min={(state.filterMode === 'stock' ? state.minMonth : state.minDate) ?? ''}
    max={(state.filterMode === 'stock' ? state.maxMonth : state.maxDate) ?? ''}
    onChange={updatePeriod}
  />
  <!-- svelte-ignore a11y_no_noninteractive_tabindex (scrollable filter summary must be keyboard reachable) -->
  <div class="filter-chips" tabindex="0" role="region" aria-label="Riepilogo filtri attivi">
    <p class="scope-summary">{scopeSummary}</p>
    {#if state.accountFilterActive}
      <button
        class="chip"
        type="button"
        onclick={() => {
          state.accountIds = [];
          state.accountFilterActive = false;
          state.syncUrl();
        }}
      >
        {state.accountIds.length ? `${state.accountIds.length} conti` : 'Nessun conto'}
        <span aria-hidden="true">×</span>
      </button>
    {/if}
    {#if state.categoryFilterActive && state.categoryFiltersAvailable}
      <button
        class="chip"
        type="button"
        onclick={() => {
          state.categoryIds = [];
          state.categoryFilterActive = false;
          state.includeUncategorized = false;
          state.syncUrl();
        }}
      >
        {state.categoryIds.length
          ? `${state.categoryIds.length} categorie${state.route === 'accounts' ? ' · movimenti' : ''}`
          : state.includeUncategorized
            ? 'Senza categoria'
            : 'Nessuna categoria'}
        <span aria-hidden="true">×</span>
      </button>
    {/if}
  </div>
  <button
    class="filter-button"
    type="button"
    aria-label="Filtri"
    aria-expanded={state.filterSheetOpen}
    onclick={() => (state.filterSheetOpen = true)}
  >
    <Icon name="filter" size={18} />
    <span>Filtri</span>
    {#if state.activeFilterCount}<span class="badge">{state.activeFilterCount}</span>{/if}
  </button>
</section>
